import React, { useEffect, useMemo, useState } from 'react';
import { withRouter } from 'react-router-dom';
import {
  Page,
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
  IconSpinner,
  InlineTextButton,
  NamedLink,
  ResponsiveImage,
  FieldRadioButton,
  Form,
  PrimaryButton,
  SecondaryButton,
} from '../../components';
import TopbarContainer from '../../containers/TopbarContainer/TopbarContainer';
import { manageDisableScrolling, isScrollingDisabled } from '../../ducks/UI.duck';
import { connect, useDispatch } from 'react-redux';
import { compose } from 'redux';

import css from './CartPage.module.css';
import { getListingsById, loadData } from './CartPage.duck';
import _ from 'lodash';
import { createSlug } from '../../util/urlHelpers';
import { formatMoney } from '../../util/currency';
import { injectIntl } from 'react-intl';
import { DeleteIcon, TruckIcon } from '../../assets';
import { addToStorage, removeFromStore } from '../../util/cartStorage';
import { transactionLineItems } from '../../util/api';
import EstimatedCustomerBreakdownMaybe from '../../components/OrderPanel/EstimatedCustomerBreakdownMaybe';
import config from '../../config';
import { fetchLineItemsError, fetchLineItemsSuccess } from '../ListingPage/ListingPage.duck';
import routeConfiguration from '../../routing/routeConfiguration';
import { createResourceLocatorString, findRouteByRouteName } from '../../util/routes';
import { getMarketplaceEntities } from '../../ducks/marketplaceData.duck';
import { initializeCardPaymentData } from '../../ducks/stripe.duck';
import fetchData from './fetchData';
const CartPage = ({
  onManageDisableScrolling,
  scrollingDisabled,
  currentUser,
  wines,
  queryInProgress,
  params,
  intl,
  history,
  getListing,
  callSetInitialValues,
  onInitializeCardPaymentData,
}) => {
  const cartWines = _.groupBy(wines, w => w?.attributes.publicData.wineryName);

  const [deliveryMethodValues, setDeliveryMethodValues] = useState(
    Object.keys(cartWines).map(k => {
      return { winery: k, value: 'shipping' };
    })
  );

  const [lineItemsToShow, setlineItemsToShow] = useState([]);

  const handleSubmit = (values, listing, k) => {
    const { bookingDates, ...otherOrderData } = values;
    const bookingDatesMaybe = bookingDates
      ? {
          bookingDates: {
            bookingStart: bookingDates.startDate,
            bookingEnd: bookingDates.endDate,
          },
        }
      : {};

    const initialValues = {
      listing,
      orderData: {
        ...bookingDatesMaybe,
        ...otherOrderData,
        lineItems: lineItemsToShow.find(l => l.key === k)?.value,
      },

      confirmPaymentError: null,
    };

    const saveToSessionStorage = !currentUser;

    const routes = routeConfiguration();
    
    if(currentUser == null) {
      localStorage.setItem('guestCheckoutFlag', true);
      localStorage.setItem('guestCheckoutProductURL', createResourceLocatorString(
        'CheckoutPage',
        routes,
        { slug: createSlug(listing.attributes.publicData.wineryName) },
        {}
      ))
    }
    
    // Customize checkout page state with current listing and selected orderData
    const { setInitialValues } = findRouteByRouteName('CheckoutPage', routes);

    callSetInitialValues(setInitialValues, initialValues, saveToSessionStorage);

    // Clear previous Stripe errors from store if there is any
    onInitializeCardPaymentData();

    // Redirect to CheckoutPage
    history.push(
      createResourceLocatorString(
        'CheckoutPage',
        routes,
        { slug: createSlug(listing.attributes.publicData.wineryName) },
        {}
      )
    );
  };

  const dispatch = useDispatch();

  // function to put delivery method as shipping by default for all if not already set
  useEffect(() => {
    if (Object.keys(cartWines).length > 0) {
      if (deliveryMethodValues.length !== Object.keys(cartWines).length) {
        setDeliveryMethodValues(
          Object.keys(cartWines).map(k => {
            return { winery: k, value: 'shipping' };
          })
        );
      }
    }
  }, [cartWines]);

  useEffect(() => {
    console.log('wines', wines);
    if (lineItemsToShow.length > 0) {
      setlineItemsToShow([]);
      fetchData(cartWines, deliveryMethodValues, setlineItemsToShow);
    } else {
      fetchData(cartWines, deliveryMethodValues, setlineItemsToShow);
    }
  }, [wines, deliveryMethodValues]);

  const buyWintButton = wine => (
    <InlineTextButton rootClassName={css.wineBannerBtn}>
      <NamedLink
        name="ListingPage"
        params={{
          slug: createSlug(wine?.attributes.title),
          id: wine?.id.uuid,
        }}
      >
        Buy now
      </NamedLink>
    </InlineTextButton>
  );

  return (
    <Page
      title="My Shopping Cart | Sommly TM"
      scrollingDisabled={scrollingDisabled}
      schema={{
        '@context': 'http://schema.org',
        '@type': 'Cart Page',
        name: 'My Shopping Cart | Sommly TM',
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer />
        </LayoutWrapperTopbar>
        <LayoutWrapperMain className={css.layoutWrapperMain}>
          <div className={css.root}>
            <div className={css.contentWrapper}>
              <div className={css.contentWrapperContainer}>
                <div className={css.layoutWrapperHeader}>
                  <h1>Your Cart</h1>
                  <h2
                    style={{
                      color: '#000',
                      fontWeight: 'bold',
                    }}
                  >
                    {wines.length} items from {Object.keys(cartWines).length} wineries
                  </h2>
                </div>

                <hr />
                <div className="div-container">
                  {queryInProgress ? (
                    <div className={css.spinnerWrapper}>
                      <IconSpinner />
                    </div>
                  ) : Object.keys(cartWines).length !== 0 ? (
                    Object.keys(cartWines).map((k, i) => (
                      <div className={css.itemsWrapper}>
                        <div className={css.productDetails}>
                          <h1
                            className={css.winerName}
                            style={{
                              color: '#000',
                            }}
                          >
                            {k}
                          </h1>
                          <span>
                            <TruckIcon style={{ fill: 'none' }} /> Shipping from{' '}
                            {cartWines[k][0]?.attributes.publicData.region},{' '}
                            {cartWines[k][0]?.attributes.publicData.state}
                          </span>

                          <span>
                            {' '}
                            <form
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'left',
                              }}
                            >
                              Shipping:
                              {cartWines[k][0]?.attributes.publicData.shippingEnabled && (<div
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  marginLeft: '10px',
                                }}
                              >
                                <input
                                  type="radio"
                                  id="myRadioButton1"
                                  name="radio-button"
                                  checked={
                                    deliveryMethodValues.find(d => d.winery === k)?.value ==
                                    'shipping'
                                  }
                                  onClick={() => {
                                    setDeliveryMethodValues(
                                      deliveryMethodValues.map((v, j) =>
                                        v.winery == k
                                          ? {
                                              winery: k,
                                              value: 'shipping',
                                            }
                                          : v
                                      )
                                    );
                                  }}
                                />{' '}
                                <span>Delivery</span>
                              </div>)}
                              {cartWines[k][0]?.attributes.publicData.pickupEnabled && (<div
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  marginLeft: '10px',
                                }}
                              >
                                <input
                                  type="radio"
                                  id="myRadioButton2"
                                  name="radio-button"
                                  checked={
                                    deliveryMethodValues.find(d => d.winery === k)?.value ==
                                    'pickup'
                                  }
                                  onClick={() => {
                                    setDeliveryMethodValues(
                                      deliveryMethodValues.map((v, j) =>
                                        v.winery == k
                                          ? {
                                              winery: k,
                                              value: 'pickup',
                                            }
                                          : v
                                      )
                                    );
                                  }}
                                />
                                <span>Pickup</span>
                              </div>)}
                            </form>{' '}
                          </span>

                          <div
                            style={{
                              width: '100%',
                            }}
                          >
                            <div>
                              {cartWines[k].map(wine => {
                                const wineTitle =
                                  wine?.attributes?.publicData?.vintage !== undefined
                                    ? wine?.attributes?.publicData?.vintage +
                                      ' ' +
                                      wine?.attributes.title
                                    : `NV ${wine?.attributes.title}`;
                                const firstImage =
                                  wine.images && wine.images.length > 0 ? wine.images[0] : null;
                                const formattedPrice = formatMoney(intl, wine?.attributes.price);

                                return (
                                  <div className={css.cartWrapper}>
                                    <div className={css.cartContainer} style={{ width: '100%' }}>
                                      <div
                                        style={{
                                          display: 'flex',
                                        }}
                                      >
                                        <div className={css.cardImgWrapper}>
                                          <ResponsiveImage
                                            alt={wineTitle}
                                            image={firstImage}
                                            variants={[
                                              'scaled-small',
                                              'scaled-medium',
                                              'scaled-large',
                                              'scaled-xlarge',
                                            ]}
                                            sizes="(max-width: 767px) 100vw, 80vw"
                                          />
                                        </div>
                                        <div className={css.titleWrapper}>
                                          <h3 className={css.wineTitle}>{wine.attributes.title}</h3>
                                          <h3
                                            className={css.wineTitle}
                                            style={{
                                              fontWeight: 'normal',
                                              maxWidth: '23vw',
                                              textAlign: 'justify',
                                            }}
                                          >
                                            {wine.attributes.description}
                                          </h3>
                                        </div>{' '}
                                      </div>

                                      <div
                                        className={css.titleWrapper}
                                        style={{
                                          display: 'flex',
                                          justifyContent: 'center',
                                          alignItems: 'center',
                                        }}
                                      >
                                        <h2 className={css.wineTitle}>{formattedPrice}</h2>
                                        <div
                                          className={css.quantityWrapper}
                                          style={{
                                            display: 'inline-block',
                                          }}
                                        >
                                          <InlineTextButton
                                            onClick={() => {
                                              addToStorage({
                                                id: wine.id.uuid,
                                                quantity: wine.quantity - 1,
                                                isOwnListing: wine.isOwnListing,
                                                wineryId: wine.attributes.publicData.wineryId,
                                              });
                                              dispatch(loadData(undefined, {}));
                                            }}
                                            rootClassName={css.wineBtnQuantity}
                                            disabled={wine.quantity <= 1}
                                          >
                                            -
                                          </InlineTextButton>
                                          <InlineTextButton rootClassName={css.wineBtnQuantity}>
                                            {wine.quantity}
                                          </InlineTextButton>
                                          <InlineTextButton
                                            onClick={() => {
                                              addToStorage({
                                                id: wine.id.uuid,
                                                quantity: wine.quantity + 1,
                                                isOwnListing: wine.isOwnListing,
                                                wineryId: wine.attributes.publicData.wineryId,
                                              });
                                              dispatch(loadData(undefined, {}));
                                            }}
                                            disabled={
                                              wine.quantity == wine.currentStock.attributes.quantity
                                            }
                                            rootClassName={css.wineBtnQuantity}
                                          >
                                            +
                                          </InlineTextButton>
                                        </div>
                                        <h3
                                          className={css.deleteButton}
                                          onClick={() => {
                                            removeFromStore(wine.id.uuid);
                                            dispatch(loadData(undefined, {}));
                                          }}
                                        >
                                          <DeleteIcon style={{ fill: 'none' }} /> <span>Remove</span>
                                        </h3>
                                      </div>
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        </div>
                        <div className={css.checkoutCard}>
                          <h2>Your Order</h2>
                          <EstimatedCustomerBreakdownMaybe
                            breakdownData={{}}
                            unitType={config.lineItemUnitType}
                            lineItems={lineItemsToShow.find(item => item.key == k)?.value}
                          />
                          <PrimaryButton
                            rootClassName={css.proccedToCheckout}
                            onClick={() => {
                              const deliveryMethod = deliveryMethodValues.find(d => d.winery == k)
                                ?.value;
                              const listing = cartWines[k][0];
                              handleSubmit(
                                {
                                  deliveryMethod: deliveryMethod,
                                  quantity: cartWines[k][0].quantity,
                                },
                                listing,
                                k
                              );
                            }}
                          >
                            Proceed to checkout
                          </PrimaryButton>
                          {/* <SecondaryButton rootClassName={css.buyNow}>Buy Now</SecondaryButton> */}
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className={css.spinnerWrapper}>Your cart is empty.</div>
                  )}{' '}
                </div>
              </div>
            </div>
          </div>
        </LayoutWrapperMain>
        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </Page>
  );
};

const mapStateToProps = state => {
  const { currentUser } = state.user;
  const {
    currentPageResultIds,
    pagination,
    queryInProgress,
    queryListingsError,
    queryParams,
  } = state.CartPage;

  const wines = getListingsById(state, currentPageResultIds);

  const getListing = id => {
    const ref = { id, type: 'listing' };

    const listings = getMarketplaceEntities(state, [ref]);
    return listings.length === 1 ? listings[0] : null;
  };

  return {
    currentUser,
    scrollingDisabled: isScrollingDisabled(state),
    pagination,
    queryInProgress,
    queryListingsError,
    queryParams,
    wines,
    getListing,
  };
};

const mapDispatchToProps = dispatch => ({
  onManageDisableScrolling: (componentId, disableScrolling) =>
    dispatch(manageDisableScrolling(componentId, disableScrolling)),
  callSetInitialValues: (setInitialValues, values, saveToSessionStorage) =>
    dispatch(setInitialValues(values, saveToSessionStorage)),

  onInitializeCardPaymentData: () => dispatch(initializeCardPaymentData()),
});

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
  injectIntl
)(CartPage);